import script from "./RACIMatrix.vue?vue&type=script&setup=true&lang=ts"
export * from "./RACIMatrix.vue?vue&type=script&setup=true&lang=ts"

import "./RACIMatrix.vue?vue&type=style&index=0&id=346c57e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-346c57e4"]])

export default __exports__